import React from 'react'

function Loading() {
    return (
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-24">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[1, 2, 3].map(i => (
                    <div key={i} className="animate-pulse">
                        <div className="bg-zinc-200 h-48 rounded-lg mb-4"></div>
                        <div className="bg-zinc-200 h-6 w-3/4 rounded mb-2"></div>
                        <div className="bg-zinc-200 h-4 w-full rounded"></div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Loading